import { toast } from "sonner";

/**
 * How long an error toast stays up. Sonner's default (4 s) is gone before most
 * messages can be read, and `toastOptions.duration` applies to every type, so
 * it would stretch success toasts too.
 */
export const ERROR_TOAST_DURATION_MS = 10_000;

let installed = false;

/**
 * Gives every `toast.error()` the longer duration unless the caller passes its
 * own (`duration`, including `Infinity`). Called once at bootstrap, so the
 * ~150 call sites keep working untouched and a new one gets it for free.
 */
export function installErrorToastDuration(): void {
  if (installed) return;
  installed = true;
  const original = toast.error.bind(toast);
  toast.error = ((message, data) =>
    original(message, { duration: ERROR_TOAST_DURATION_MS, ...data })) as typeof toast.error;
}
